import { SelectOption } from '../../../components/Form/Select'

import { Category } from '../../../services/category'
import { Person } from '../../../services/person'

export function categoryToSelectOption(category: Category): SelectOption {
  return {
    key: category.id,
    value: category.id,
    text: category.name
  }
}

export function personToSelectOption(person: Person): SelectOption {
  return {
    key: person.id,
    value: person.id,
    text: `${person.name}${person.document ? ' - ' + person.document : ''}`
  }
}
